var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-container"},[_c('export-options',{attrs:{"exportUrl":_vm.exportUrl,"repository":_vm.repository,"resource":_vm.resource,"tableRef":_vm.$refs[_vm.tableRef],"filter":_vm.filter,"options":[
      {
        code: 'EXPOCLAI',
        label: null,
        formats: ['csv', 'pdf'],
      },
    ]}}),_vm._v(" "),_c('table-claims',{ref:_vm.tableRef,staticClass:"mt-2",attrs:{"isTableInModal":true,"fields":_vm.fields,"repository":"claim","resource":"claims","filterName":_vm.filterName,"onlyActions":['infomodal'],"noInnerWidth":"","noInputPaginator":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }